import React from "react";
import { Button, Card } from "react-bootstrap";
import "../../styles/components/TransactionSummary.scss";

const TransactionSummaryRow = (props) => {
  const data = props.data;
  console.log("123");
  console.log(data);
  let total = 0;
  return (
    <>
      <div className="my-flex">
        <Card className="m-2 card py-1 px-1" style={{ width: "100%" }}>
          <Card.Body className="card-data d-flex p-2">
            {Object.entries(data).map(([key, value]) => (
              <div style={{ width: "25%" }}>
                <h6 style={{ color: "#919191" }}>{key}</h6>
                <strong
                  style={{
                    color: "black",
                    "font-weight": "700",
                    "font-size": "17px",
                  }}
                >
                  {value}
                </strong>
              </div>
            ))}
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default TransactionSummaryRow;
